import { useMemo } from 'react';
import { encodeQr } from '../lib/qr';

/** A QR code as inline SVG (dark modules on white, 4-module quiet zone). */
export function QrCode({
  value,
  size = 192,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) {
  const { path, dim } = useMemo(() => {
    const m = encodeQr(value);
    const quiet = 4;
    let d = '';
    m.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) d += `M${x + quiet} ${y + quiet}h1v1h-1z`;
      }),
    );
    return { path: d, dim: m.length + quiet * 2 };
  }, [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      width={size}
      height={size}
      viewBox={`0 0 ${dim} ${dim}`}
      shapeRendering="crispEdges"
      className="rounded border bg-white"
    >
      <rect width={dim} height={dim} fill="#fff" />
      <path d={path} fill="#000" />
    </svg>
  );
}
